<app-grid
  #grid
  *ngIf="!loading"
  [columnDefs]="columnDef"
  [rowData]="rowData"
  [rowSelection]="showResults ? 'multiple' : 'single'"
  [selectedProject]="selectedProject"
  [suppressRowClickSelection]="showResults"
  [useSelectAll]="showResults && isProjectOwnershipValid"
  (onSelectedRowEvent)="onSelectedRowEvent($event)"
  (onSelectAllClicked)="onSelectedAllChanged()"
/>

<app-loading *ngIf="loading"/>
